export const getUrlWithToken = (url: string, token: string) => {
  if (url && url !== '' && !url.startsWith('blob:') && !url.startsWith('data:') && token !== '') {
    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set('token', encodeURIComponent(token));

      return urlObj.toString();
    } catch (error) {
      console.error('Error parsing URL:', error);
      return url;
    }
  }
  return url;
};
